import { useState } from 'react';
import { getDataWithToken, GET_DETAILED_LOG_URL } from 'Utils/api';
import Location from 'Models/Location';

/**
 * Ported from the old tracking screen's GET_DETAILED_LOG saga
 * (sagas/trips.js) - same param renames (startDate -> from, endDate -> to,
 * trackingType -> tracking_type) and the same client-side-only pagination
 * (DetailedLog itself infers "has next page" from locations.length >= limit,
 * there's no next/prev token from the backend).
 */
export const useDetailedLog = (tripId) => {
  const [locations, setLocations] = useState([]);
  const [isLoaded, setIsLoaded] = useState(true);

  const search = (searchText, startDate, endDate, trackingType, offset, limit, order_by) => {
    setIsLoaded(false);
    getDataWithToken(GET_DETAILED_LOG_URL, {
      trip_id: tripId,
      from: startDate,
      to: endDate,
      search: searchText,
      tracking_type: trackingType,
      offset,
      limit: limit || 10,
      order_by,
    })
      .then((response) => {
        const rows = ((response && response.data && response.data.locations) || []).map((loc) => new Location(loc));
        setLocations(rows);
      })
      .catch((error) => {
        console.log('[TripTrackingV2] detailed log error:', error);
        setLocations([]);
      })
      .finally(() => setIsLoaded(true));
  };

  return { locations, isLoaded, search };
};
